import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatButtonModule} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {
  IconButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';

import {DvGenerationStatusComponent} from './dv-generation-status.component';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [DvGenerationStatusComponent],
  imports: [
    CommonModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    TranslateModule,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    IconButtonComponent,
    MatIconModule
  ],
  exports: [DvGenerationStatusComponent]
})
export class DvGenerationStatusModule {}
